<template lang="pug">
  div
    top
    platforms
    what-we
    what-we-box
    portfolio
    testimony
    .clear
</template>

<script>
import Top from '@/views/Top'
import Platforms from '@/views/Platforms'
import WhatWe from '@/views/WhatWe'
import WhatWeBox from '@/views/WhatWeBox'
import Portfolio from '@/views/Portfolio'
import Testimony from '@/views/Testimony'

export default {
  name: 'home',
  components: {
    Top,
    Platforms,
    WhatWe,
    WhatWeBox,
    Portfolio,
    Testimony
  }
}
</script>
